import ApiClient from ".."

// In DTOs
import QuizPostCoachOnboardingIn from "../../dtos/in/QuizPostCoachOnboardingIn"
import type QuizPostCoachingIn from "../../dtos/in/QuizPostCoachingIn"
import type QuizPostReportAdjustmentIn from "../../dtos/in/QuizPostReportAdjustmentIn"
import type QuizPostReportIn from "../../dtos/in/QuizPostReportIn"
import QuizPostSubscriptionCancellationIn from "../../dtos/in/QuizPostSubscriptionCancellationIn"

// Out DTOs
import GenericOut from "../../dtos/out/GenericOut"
import QuizGetCoachingAnswersOut from "../../dtos/out/QuizGetCoachingAnswersOut"
import QuizGetReportAnswersOut from "../../dtos/out/QuizGetReportAnswersOut"

export class QuizEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/quiz"

  /**
   * Creates a user's coaching quiz record.
   */
  async postCoaching(payload: QuizPostCoachingIn) {
    return this.client.post<GenericOut>(QuizEndpoints.BASE_URL, "/coaching", payload)
  }

  /**
   * Creates a coach's onboarding quiz record.
   */
  async postCoachOnboarding(payload: QuizPostCoachOnboardingIn) {
    return this.client.post<GenericOut>(QuizEndpoints.BASE_URL, "/coach-onboarding", payload)
  }

  /**
   * Creates a user's report quiz record.
   */
  async postReport(payload: QuizPostReportIn) {
    return this.client.post<GenericOut>(QuizEndpoints.BASE_URL, "/report", payload)
  }

  /**
   * Duplicates the user's report quiz answers, and updates key variables included in the payload.
   */
  async postReportAdjustment(payload: QuizPostReportAdjustmentIn) {
    return this.client.post<GenericOut>(QuizEndpoints.BASE_URL, "/report/adjustment", payload)
  }

  /**
   * Creates or upserts a user's subscription cancellation quiz answers for a specific subscription if it has not been marked as cancelled yet.
   */
  async postSubscriptionCancellation(payload: QuizPostSubscriptionCancellationIn) {
    return this.client.post<GenericOut>(QuizEndpoints.BASE_URL, "/subscription-cancellation", payload)
  }

  /**
   * Retrieves the user's coaching quiz answers.
   */
  async getCoachingQuizAnswers() {
    return this.client.get<QuizGetCoachingAnswersOut>(QuizEndpoints.BASE_URL, "/coaching/answers")
  }

  /**
   * Retrieves the user's report quiz answers.
   */
  async getReportQuizAnswers() {
    return this.client.get<QuizGetReportAnswersOut>(QuizEndpoints.BASE_URL, "/report/answers")
  }

  /**
   * Retrieves any user's report quiz answers by userId.
   * @param userId The user ID to retrieve answers for.
   */
  async getReportQuizAnswersByUserId(userId: number) {
    return this.client.get<QuizGetReportAnswersOut>(QuizEndpoints.BASE_URL, `/user/${userId}/report/answers`)
  }
}
